<section class="drive-band band--lane">
  <div class="band-media" [appParallax]="{ y: [-5, 5], scale: [1.12, 1] }" aria-hidden="true">
    <img src="assets/images/background/wheel-1600.jpg" alt="" width="1600" height="1600" loading="lazy" decoding="async" />
  </div>
  <div class="band-tint band-tint--deep" aria-hidden="true"></div>
  <div class="container band-content practice-layout">
    <div class="practice-story" appReveal="rise">
      <span class="practice-road" aria-hidden="true"></span>
      <h2>{{ 'backgroundImg-text' | translate }}</h2>
    </div>
    <div class="practice-card" appReveal="rise" revealDelay="0.15">
      <p class="design-eyebrow brand-mark">{{ 'home.design.testLabel' | translate }}</p>
      <h3>{{ 'quizes.header' | translate }}</h3>
      <p class="practice-note">{{ 'home.design.testNote' | translate }}</p>
      <a class="dv-pill dv-pill--light cta-sheen" appMagnetic [routerLink]="link('/quiz/v2/abc')">
        <span class="magnetic-label">{{ 'navbar.quiz_list' | translate }}</span>
        <span class="brand-icon brand-icon--arrow dv-arrow" aria-hidden="true"></span>
      </a>
    </div>
  </div>
</section>
